import PlaneAction from "./PlaneAction.js";
import {turn} from "../planeSlice.js";
import {addHeading} from "../../assets/virtual-flyout/nav-calc.js";

export default class TurnDegrees extends PlaneAction {
    constructor(planeId, degrees) {
        super(planeId);
        this.degrees = degrees;
    }

    execute() {
        const direction = this.degrees > 0 ? "right" : "left";
        this.log(`Turning ${Math.abs(this.degrees)}° ${direction}`)
        const planeState = this.getState();
        this.newHeading = addHeading(planeState.heading, this.degrees);
        this.dispatch(turn({ roll: Math.sign(this.degrees), heading: this.newHeading }));
    }

    isComplete() {
        const planeState = this.getState();
        return planeState.heading === this.newHeading;
    };
}